import React from "react";
import Layout from "../components/Layout";
import Carousel from "../components/Carousel";
import { Clock, ShieldCheck, Star, Phone, Upload, Cog, Truck, CheckCircle } from "lucide-react";
import "../index.css";

function Home() {
  return (
    <Layout>
      <div className="min-h-screen text-gray-900 dark:text-white transition-all duration-300">

        {/* Carousel Section */}
        <Carousel />

        {/* Main Content */}
        <main className="relative">

          {/* Hero Section */}
<section className="text-center py-24 px-4">
  <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-green dark:bg-gradient-to-r from-emerald-400 to-emerald-300 bg-clip-text text-transparent tracking-tight leading-tight">
    Digital Implant-Focused <br className="hidden md:block" />
    Dental Laboratory – UK
  </h1>

  <p className="text-lg md:text-2xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto leading-relaxed">
    High-precision implant, full-arch and CAD/CAM solutions 
    for private clinics seeking predictable digital results.
  </p>

  {/* Divider */}
  <div className="w-20 h-1 bg-green dark:bg-gradient-to-r from-[#025951] to-emerald-400 mx-auto rounded-full mt-8 mb-12"></div>

  {/* Feature Grid */}
  <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-x-16 gap-y-4 text-left">
    <div className="flex items-start gap-3">
      <span className="w-2 h-2 mt-3 bg-[#025951] dark:bg-emerald-400 rounded-full"></span>
      <p className="text-lg text-gray-700 dark:text-gray-300">
        Implant & Full-Arch specialists
      </p>
    </div>

    <div className="flex items-start gap-3">
      <span className="w-2 h-2 mt-3 bg-[#025951] dark:bg-emerald-400 rounded-full"></span>
      <p className="text-lg text-gray-700 dark:text-gray-300">
        Custom abutments (all implant systems)
      </p>
    </div>

    <div className="flex items-start gap-3">
      <span className="w-2 h-2 mt-3 bg-[#025951] dark:bg-emerald-400 rounded-full"></span>
      <p className="text-lg text-gray-700 dark:text-gray-300">
        Exocad digital workflow
      </p>
    </div>

    <div className="flex items-start gap-3">
      <span className="w-2 h-2 mt-3 bg-[#025951] dark:bg-emerald-400 rounded-full"></span>
      <p className="text-lg text-gray-700 dark:text-gray-300">
        3Shape   Medit   iTero compatible
      </p>
    </div>

    <div className="flex items-start gap-3 md:col-span-2">
      <span className="w-2 h-2 mt-3 bg-[#025951] dark:bg-emerald-400 rounded-full"></span>
      <p className="text-lg text-gray-700 dark:text-gray-300">
        UK-wide service with precision-focused production
      </p>
    </div>
  </div>

  
</section>

          {/* Why Choose Section */}
          <section className="py-20 px-4 bg-white/50 dark:bg-neutral-700/30 backdrop-blur-sm">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-16">
                <h2 className="text-3xl md:text-5xl font-bold mb-6 text-gray-900 dark:text-white uppercase tracking-wide">
                  Why Choose FelixDent Lab
                </h2>
                <div className="w-32 h-1 bg-green dark:bg-gradient-to-r from-[#025951] to-emerald-400 mx-auto rounded-full"></div>
              </div>

              <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
                {/* Top Notch Service */}
                <div className="group bg-white dark:bg-neutral-800 p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200 dark:border-neutral-500 hover:border-[#025951] dark:hover:border-emerald-400 hover:scale-105">
                  <div className="w-16 h-16 bg-green dark:bg-gradient-to-br from-[#025951] to-emerald-400 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Star className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-center text-gray-900 dark:text-white uppercase">
                    Top Notch Service
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300 text-center leading-relaxed">
                    Quality dental 3D printing is our main objective. We use the best bio compatible materials that produce exceptional results.
                  </p>
                </div>

                {/* Decent Turnaround Time */}
                <div className="group bg-white dark:bg-neutral-800 p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200 dark:border-neutral-500 hover:border-[#025951] dark:hover:border-emerald-400 hover:scale-105">
                  <div className="w-16 h-16 bg-green dark:bg-gradient-to-br from-[#025951] to-emerald-400 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Clock className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-center text-gray-900 dark:text-white uppercase">
                    Fast Turnaround
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300 text-center leading-relaxed">
                    We value your time, and understand how important is to process all the orders fast. Fast shipping with Royal Mail.
                  </p>
                </div>

                {/* Secure Payments */}
                <div className="group bg-white dark:bg-neutral-800 p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200 dark:border-neutral-500 hover:border-[#025951] dark:hover:border-emerald-400 hover:scale-105">
                  <div className="w-16 h-16 bg-green dark:bg-gradient-to-br from-[#025951] to-emerald-400 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                    <ShieldCheck className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-center text-gray-900 dark:text-white uppercase">
                    Secure Payments
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300 text-center leading-relaxed">
                    All the sensitive data is encrypted during checkout. We accept Visa, MasterCard, Apple Pay, Google Pay, etc.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* How It Works Section */}
          <section className="py-20 px-4">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-16">
                <h2 className="text-3xl md:text-5xl font-bold mb-6 bg-green dark:bg-gradient-to-r from-emerald-400 to-emerald-300 bg-clip-text text-transparent uppercase tracking-wide">
                  How It Works
                </h2>
                <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
                  Our streamlined process ensures quality results every time
                </p>
                <div className="w-32 h-1 bg-green dark:bg-gradient-to-r from-[#025951] to-emerald-400 mx-auto rounded-full mt-6"></div>
              </div>

              <div className="space-y-8">
                {[
                  {
                    icon: Phone,
                    title: "Get in Touch",
                    content: (
                      <>
                        Call us at <a href="tel:+447305959777" className="text-[#025951] dark:text-emerald-400 font-semibold hover:underline transition-colors">+44 7305 959777</a> or send a message via WhatsApp to request a free quote and get to know each other.
                      </>
                    )
                  },
                  {
                    icon: Upload,
                    title: "Submit Your New Order",
                    content: "Upload your design files through our secure Dropbox."
                  },
                  {
                    icon: CheckCircle,
                    title: "We Verify, Design and Approve Your Order",
                    content: "Our expert team designs or checks your files to ensure precision and compatibility."
                  },
                  {
                    icon: Cog,
                    title: "Milling & 3D Printing",
                    content: "We use high-end machines for accurate milling or 3D printing. Quality is our commitment."
                  },
                  {
                    icon: Truck,
                    title: "Fast Dispatch",
                    content: "Your finished order is carefully packed and shipped the next working day."
                  }
                ].map((step, index) => (
                  <div key={index} className="flex items-start gap-6 bg-white dark:bg-neutral-700 p-8 rounded-2xl shadow-lg border border-gray-200 dark:border-neutral-500 hover:shadow-xl transition-all duration-300 group hover:border-[#025951] dark:hover:border-emerald-400">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-green dark:bg-gradient-to-br from-[#025951] to-emerald-400 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <step.icon className="w-6 h-6 text-white" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold mb-3 text-gray-900 dark:text-white">{step.title}</h3>
                      <p className="text-gray-600 dark:text-gray-300 leading-relaxed text-lg">{step.content}</p>
                    </div>
                    <div className="text-3xl font-bold text-[#025951] dark:text-emerald-400 opacity-20 group-hover:opacity-40 transition-opacity duration-300">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="py-20 px-4 bg-green dark:from-emerald-600 dark:to-emerald-400">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white">
                Ready to Get Started?
              </h2>
              <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
                Join hundreds of satisfied dental professionals who trust FelixDent for their laboratory needs.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="/contact-us"
                  className="bg-white text-[#025951] font-semibold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 inline-flex items-center justify-center"
                >
                  <Phone className="w-5 h-5 mr-2" />
                  Contact Us Today
                </a>
                <a
                  href="/orderproducts"
                  className="bg-transparent border-2 border-white text-white font-semibold py-4 px-8 rounded-full hover:bg-white hover:text-[#025951] transition-all duration-300 hover:scale-105 inline-flex items-center justify-center"
                >
                  <Star className="w-5 h-5 mr-2" />
                  View Products
                </a>
              </div>
            </div>
          </section>

          {/* Contact Strip */}
          <section className="py-8 bg-white dark:bg-neutral-700 border-t border-gray-200 dark:border-neutral-600">
            <div className="max-w-6xl mx-auto px-4 text-center">
              <div className="flex flex-col md:flex-row items-center justify-center gap-8">
                <div className="flex items-center">
                  <Phone className="w-6 h-6 text-[#025951] dark:text-emerald-400 mr-3" />
                  <span className="text-gray-700 dark:text-gray-300 font-medium">
                    Call us: <a href="tel:+447305959777" className="text-[#025951] dark:text-emerald-400 hover:underline">+44 7305 959777</a>
                  </span>
                </div>
                <div className="hidden md:block w-px h-8 bg-gray-300 dark:bg-neutral-500"></div>
                <div className="flex items-center">
                  <CheckCircle className="w-6 h-6 text-[#025951] dark:text-emerald-400 mr-3" />
                  <span className="text-gray-700 dark:text-gray-300 font-medium">Quality Guaranteed</span>
                </div>
                <div className="hidden md:block w-px h-8 bg-gray-300 dark:bg-neutral-500"></div>
                <div className="flex items-center">
                  <Truck className="w-6 h-6 text-[#025951] dark:text-emerald-400 mr-3" />
                  <span className="text-gray-700 dark:text-gray-300 font-medium">Fast Delivery</span>
                </div>
              </div>
            </div>
          </section>

        </main>
      </div>
    </Layout>
  );
}

export default Home;